import { ISyncedProduct } from "reducer/utils.reducer";
import { ISetSyncedProductAction } from "../interfaces/utils.interface";
export function setSyncedProduct(syncedProduct: ISyncedProduct | null): ISetSyncedProductAction {
  return {
    type: "SET_SYNCED_PRODUCT",
    data: syncedProduct,
  };
}
